import { render, staticRenderFns } from "./discardChangesModal.vue?vue&type=template&id=7a5c5395&scoped=true"
import script from "./discardChangesModal.vue?vue&type=script&lang=js"
export * from "./discardChangesModal.vue?vue&type=script&lang=js"
import style0 from "./discardChangesModal.vue?vue&type=style&index=0&id=7a5c5395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5c5395",
  null
  
)

export default component.exports